import React, { useState, useEffect, useRef } from 'react';
import { Field, Formik, Form } from 'formik'
import { TextInput, TextArea } from '../../../../components';
import Constants from '../../../../Constants';
import useAxios from '../../../../hooks/useAxios';


const AddTeam = ({ onSubmit, onCancel, isSubmittingForm, selectedTeam }) => {

    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const { getData } = useAxios();
    
    const dropdownRef = useRef(null);

    const filteredUsers = users.filter(
        (user) =>
            (user.firstName.toLowerCase().includes(search.toLowerCase()) ||
             user.lastName.toLowerCase().includes(search.toLowerCase()) ||
             user.email.toLowerCase().includes(search.toLowerCase())) &&
            !(selectedTeam?.userIds || []).includes(user._id)
    );

    useEffect(() => {
        const handleClickOutside = e => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await getData(`${Constants.ApiUrl.user.getUsers}`);
            if (response.success) {
                setUsers(response.data.users);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    return (
        <Formik
            initialValues={{
                name: selectedTeam ? selectedTeam?.name : '',
                description: selectedTeam ? selectedTeam?.description : '',
                userIds: selectedTeam ? selectedTeam?.userIds : [],
            }}
            enableReinitialize={true}
            onSubmit={(values, { setErrors }) => {
                const payload = {
                    ...values,
                    userIds: values.userIds.map(user => user._id), // <-- only send _id
                };

                onSubmit(true, payload, setErrors, selectedTeam);
            }}
        >
            {() => (
                <Form>
                    <div className="add-form p-0">
                        <div className="p-4">
                            <div className="row pt-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <Field name="name" placeholder="Enter Name" label="Name" component={TextInput} />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <Field name="description" placeholder="Enter Description" label="Description" component={TextArea} />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div
                                        className="flex flex-wrap gap-2 px-2 py-1 border rounded"
                                    >
                                        <Field name="userIds">
                                            {({ field, form }) => (
                                                <div className="form-group">
                                                    <label className="label-style">Users</label>
                                                    <div ref={dropdownRef}>
                                                        <input
                                                            className="input-field-style"
                                                            placeholder="Search or add..."
                                                            value={search}
                                                            onFocus={() => setShowDropdown(true)}
                                                            onChange={(e) => {
                                                                setSearch(e.target.value);
                                                                setShowDropdown(true);
                                                            }}
                                                        />
                                                        {showDropdown && (
                                                            <div className="absolute mt-1 bg-white border rounded z-10">
                                                                {filteredUsers.length > 0 ? (
                                                                    filteredUsers.map((item, idx) => {
                                                                        const isSelected = field?.value?.some(
                                                                            (user) => user._id === item._id
                                                                        );
                                                                        return (
                                                                            <div
                                                                                key={idx}
                                                                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer multi-select-dropdown d-flex align-items-center"
                                                                                onClick={() => {
                                                                                    const currentValue = Array.isArray(field.value) ? field.value : [];
                                                                                    const isSelected = currentValue.some(team => team._id === item._id);

                                                                                    const newSelection = isSelected
                                                                                        ? currentValue.filter(team => team._id !== item._id)
                                                                                        : [...currentValue, item];

                                                                                    form.setFieldValue("userIds", newSelection);
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="me-2"
                                                                                    checked={isSelected}
                                                                                    readOnly
                                                                                />
                                                                                <span>{`${item.firstName} ${item.lastName}`}</span>
                                                                            </div>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <div className="px-4 py-2">No matches found.</div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                                        {field?.value?.map((user, id) => (
                                                            <div
                                                                key={id}
                                                                className="badge bg-secondary text-white d-flex align-items-center">
                                                                {`${user.firstName} ${user.lastName}`}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        const updated = field.value.filter((t) => t._id !== user._id);
                                                                        form.setFieldValue("userIds", updated);
                                                                    }}
                                                                    className="btn btn-sm btn-light ms-2">
                                                                    <i className="fa fa-times text-dark" />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button onClick={onCancel} type="button" className="btn btn-theme btn-border">
                                        Cancel
                                    </button>
                                    <button disabled={isSubmittingForm} type="submit" className="btn btn-theme">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export default AddTeam;